export const Log = (...args) => {
    if (!wp_dark_mode_json.debug) return;

};
